import { render, staticRenderFns } from "./ShipmentIndex.vue?vue&type=template&id=73fdff77&"
import script from "./ShipmentIndex.vue?vue&type=script&lang=js&"
export * from "./ShipmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShipmentIndex.vue"
export default component.exports